import React, { Component } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import ModalWrapper from '../../../components/ModalWrapper';
import Button from '../../../components/Button';
import QmImage from '../../../components/Image/QmImage';
import Checkbox from '../../../components/Checkbox/Checkbox';
import { getUserAPI } from '../../../services/API';
import { configs, USER_PHOTO } from '../config';

import qmStyles from '../../../theme/qmStyles';
import componentStyles from './TOSModal.scss';

const TOSStepConfig = configs[USER_PHOTO];
export default class TOSModal extends Component {
  constructor(props) {
    super(props);
    this.state = { caslChecked: false };
  }

  toggleCaslChecked = () => {
    this.setState(({ caslChecked }) => ({
      caslChecked: !caslChecked,
    }));
  };

  handleTOSAgree = () => {
    const { navigateNext, userData, closeModal } = this.props;
    const { caslChecked } = this.state;

    if (caslChecked) {
      const instanceAPI = getUserAPI();

      instanceAPI
        .UserService()
        .update(null, userData.id, { communication_settings: { PROMO: true } })
        .then(() => {
          closeModal();
          navigateNext({}, TOSStepConfig);
        });
      return;
    }

    closeModal();
    navigateNext({}, TOSStepConfig);
  };

  render() {
    const { closeModal, isOpen } = this.props;
    const { caslChecked } = this.state;
    return (
      <ModalWrapper
        closeModal={closeModal}
        isOpen={isOpen}
        className={componentStyles.TOSModal}
        overlayClassName={componentStyles.TOSModalOverlay}
      >
        {() => (
          <div className="layout--column" style={{ height: '100%' }}>
            <div className={componentStyles.modalBackgroundImageContainer} />
            <div className={componentStyles.modalContentContainer}>
              <h3>
                Our{' '}
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.quartermaster.house/terms-of-service"
                >
                  Terms of Service
                </a>{' '}
                and{' '}
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.quartermaster.house/privacy-policy"
                >
                  Privacy Policy
                </a>
              </h3>
              <QmImage
                src="static/webBeta/agree-tos.png"
                width={138}
                height={150}
              />
              <h4>Our Quartermaster Promise</h4>
              <p>
                We're committed to protecting your personal info. Your data will
                always belong to you, and it will only be used to customize your
                Quartermaster experience.
              </p>
            </div>
            <div
              className={classNames(
                'self-center',
                componentStyles.caslCheckboxContainer,
              )}
            >
              <Checkbox
                value={caslChecked}
                onChange={this.toggleCaslChecked}
                text="I agree to receive promotional emails from Quartermaster."
              />
            </div>
            <div
              className="layout--row layout-align--space-between-center"
              style={{ padding: 32 }}
            >
              <Button
                text="Back"
                onClick={closeModal}
                style={{
                  border: 'none',
                  height: 40,
                  width: 30,
                }}
              />
              <Button
                text="Agree"
                onClick={this.handleTOSAgree}
                style={{
                  borderColor: qmStyles.qmBabyGreen,
                  backgroundColor: qmStyles.qmBabyGreen,
                  color: qmStyles.white,
                  width: 100,
                  height: 40,
                }}
              />
            </div>
          </div>
        )}
      </ModalWrapper>
    );
  }
}

TOSModal.propTypes = {
  // showNetworkError: PropTypes.bool.isRequired,
  // networkErrorMessage: PropTypes.string.isRequired,
};
